module.exports = __webpack_public_path__ + "static/logoNUAthens-81c7b4daf96dc5097c0ad8121eb8d47a.png";